/* Drafts and the retry queue (ADR 0018). Tokens only. */

.list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-4) 0;
  border-bottom: 1px solid var(--rule);
}

.item p {
  margin: 0;
}

.itemHeading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.meta {
  color: var(--graphite);
  font: var(--t-small);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.empty {
  margin: 0;
}

.queued {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}
